<div class="container-fluid py-4">
  <div class="py-4 heading-container">
    <div class="d-inline-block align-middle me-2">
      <svg-icon src="assets/icons/icon-projects.svg" class="icon-projects"> </svg-icon>
    </div>

    <h1 [attr.data-test-id]="'page-title'" class="d-inline-block align-middle m-0">
      {{ 'PROJECT_TITLE_HINT' | translate }}
    </h1>
  </div>

  <div class="py-4">
    <button type="button" routerLink="/projects/create" class="btn btn-primary" data-test-id="create-project">
      {{ 'BTN_CREATE_PROJECT' | translate }}
    </button>
  </div>

  <ul #nav="ngbNav" ngbNav type="pills" (navChange)="onTabClick($event)" class="nav-tabs">
    <li ngbNavItem="all_social_groups">
      <a ngbNavLink [attr.data-test-id]="'all_social_groups'">
        {{ 'MY_PROJECTS_TAB_HINT' | translate }} ({{ (counters$ | async).verifiedCounter }})
      </a>

      <ng-template *ngIf="activeTab$ | async as tab" ngbNavContent>
        <app-search-input
          [label]="SEARCH_INPUT_LABEL"
          [value]="tab.queryKeyword"
          (valueChanged)="onKeywordChanged($event)"
        ></app-search-input>

        <ng-container *ngIf="tab.mode === ListMode.BROWSE">
          <app-spinner>
            <app-items-list
              [items]="userSocialGropus$ | async"
              [type]="CardType.PROJECT"
              [searchState]="{ pagination: tab.pagination }"
              [noItemsTitle]="'PROJECTS_NO_PROJECTS'"
              (pageChanged)="onPageChanged($event)"
            ></app-items-list>
          </app-spinner>
        </ng-container>

        <ng-container *ngIf="tab.mode === ListMode.SEARCH">
          <div *ngIf="(searchSocialGroup$ | async).length" class="mt-3">
            <app-sort-drop-down
              [ascending]="(sortParams$ | async).ascending"
              [currentSortCategory]="(sortParams$ | async).orderType"
              [isLoading]="isLoading$ | async"
              [sortOptions]="SORT_OPTIONS"
              (toggleSortingByType)="toggleSortingOrderByType($event)"
            >
            </app-sort-drop-down>
          </div>

          <app-spinner>
            <ng-container *ngIf="(searchSocialGroup$ | async).length; else emptyResult">
              <app-items-list
                [items]="searchSocialGroup$ | async"
                [type]="CardType.PROJECT"
                [searchState]="{ pagination: tab.pagination }"
                [noItemsTitle]="''"
                (pageChanged)="onPageChanged($event)"
              ></app-items-list>
            </ng-container>

            <ng-template #emptyResult>
              <p class="p-3" [innerHTML]="'SEARCH_NO_RESULT_HINT' | translate: { keyword: tab.queryKeyword }"></p>
            </ng-template>
          </app-spinner>
        </ng-container>
      </ng-template>
    </li>

    <li ngbNavItem="sent_requests">
      <a ngbNavLink [attr.data-test-id]="'sent_requests'">
        {{ 'SENT_PROJECTS_REQUESTS_TAB_HINT' | translate }} ({{ (counters$ | async).sentCounter }})
      </a>

      <ng-template *ngIf="activeTab$ | async as tab" ngbNavContent>
        <app-spinner>
          <app-grid-users-list
            [currentPage]="tab.pagination.currentPage"
            [pageSize]="tab.pagination.limit"
            [totalCount]="tab.pagination.totalItemsCount"
            (pageChange)="onPageChanged($event)"
            [pagination]="true"
            [constructorData]="requestsTableData$ | async"
            [noUsersHint]="'NO_NEW_SENT_PROJECTS_REQUESTS_TEXT'"
            [sortOptions]="SORT_OPTIONS"
            [currentSortCategory]="(sortParams$ | async).orderType"
            [ascending]="(sortParams$ | async).ascending"
            (action)="onTableAction($event)"
            (toggleSorting)="onSortParamChanged($event)"
            (toggleSortingByType)="toggleSortingOrderByType($event)"
          ></app-grid-users-list>
        </app-spinner>
      </ng-template>
    </li>

    <li ngbNavItem="got_invitations">
      <a ngbNavLink [attr.data-test-id]="'got_invitations'">
        {{ 'GOT_PROJECTS_INVITATIONS_TAB_HINT' | translate }} ({{ (counters$ | async).receivedCounter }})
      </a>

      <ng-template *ngIf="activeTab$ | async as tab" ngbNavContent>
        <app-spinner>
          <app-grid-users-list
            [currentPage]="tab.pagination.currentPage"
            [pageSize]="tab.pagination.limit"
            [totalCount]="tab.pagination.totalItemsCount"
            (pageChange)="onPageChanged($event)"
            [pagination]="true"
            [constructorData]="invitesTableData$ | async"
            [noUsersHint]="'NO_NEW_GOT_PROJECTS_INVITATIONS_TEXT'"
            [sortOptions]="SORT_OPTIONS"
            [currentSortCategory]="(sortParams$ | async).orderType"
            [ascending]="(sortParams$ | async).ascending"
            (action)="onTableAction($event)"
            (toggleSorting)="onSortParamChanged($event)"
            (toggleSortingByType)="toggleSortingOrderByType($event)"
          ></app-grid-users-list>
        </app-spinner>
      </ng-template>
    </li>
  </ul>

  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
